document.addEventListener('DOMContentLoaded', function () {
    const openers = document.querySelectorAll('.js-pequip-open');

    openers.forEach((opener) => {
        opener.addEventListener('click', () => {
            const id = opener.getAttribute('aria-controls');
            const modal = id ? document.getElementById(id) : null;
            if (!modal) return;

            modal.classList.add('is-open');
            modal.setAttribute('aria-hidden', 'false');
            document.documentElement.style.overflow = 'hidden';
            document.body.style.overflow = 'hidden';

            const closeBtn = modal.querySelector('.js-pequip-close');

            const doClose = () => {
                modal.classList.remove('is-open');
                modal.setAttribute('aria-hidden', 'true');
                document.documentElement.style.overflow = '';
                document.body.style.overflow = '';
                modal.removeEventListener('click', onBackdrop);
                document.removeEventListener('keydown', onEsc);
                if (closeBtn) closeBtn.removeEventListener('click', doClose);
            };

            const onEsc = (e) => {
                if (e.key === 'Escape') doClose();
            };

            const onBackdrop = (e) => {
                if (e.target.classList.contains('pequip__modal')) doClose();
            };

            if (closeBtn) closeBtn.addEventListener('click', doClose);
            modal.addEventListener('click', onBackdrop);
            document.addEventListener('keydown', onEsc);
        });
    });
});
